import { Document, SystemFieldNames } from './document.model';
import produce from 'immer';
import moment from 'moment';

export class DocumentWriter {
  private fields: { [key: string]: any } = {};
  private origDocument: Document;

  constructor(document: Document) {
    this.origDocument = document;
  }

  public set uId(value: string) {
    this.setFieldValue(SystemFieldNames.uId, value);
  }

  public set summary(value: string) {
    this.setFieldValue(SystemFieldNames.summary, value);
  }

  public set details(value: string) {
    this.setFieldValue(SystemFieldNames.details, value);
  }

  public set dateCreated(value: any) {
    this.setFieldValue(SystemFieldNames.dateCreated, moment(value).toISOString());
  }

  public set createdBy(value: string) {
    this.setFieldValue(SystemFieldNames.createdBy, value);
  }

  public set dateUpdated(value: any) {
    this.setFieldValue(SystemFieldNames.dateUpdated, moment(value).toISOString());
  }

  public set updatedBy(value: string) {
    this.setFieldValue(SystemFieldNames.updatedBy, value);
  }

  public set workflowUId(value: string) {
    this.setFieldValue(SystemFieldNames.workflowUId, value);
  }

  public set workflowStepUId(value: string) {
    this.setFieldValue(SystemFieldNames.workflowStepUId, value);
  }

  public set cultureCode(value: string) {
    this.setFieldValue(SystemFieldNames.cultureCode, value);
  }

  public get document(): Document {
    return produce(this.origDocument, draftState => {
      for (const key in this.fields) {
        if (this.fields.hasOwnProperty(key)) {
          draftState[key] = this.fields[key];
        }
      }
    });
  }

  public setFieldValue(name: string, value: any): void {
    this.fields[name] = value === undefined ? null : value;
  }
}
